import { rest } from 'msw'

const authHandlers = [
  rest.post('*/auth/exchange-token', (req, res, ctx) => {
    return res(ctx.status(200), ctx.json({ dashboard_token: 'true' }))
  }),
]

export default authHandlers
